import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert/Alert';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import './MensajeToken.css'
import { Button } from '@material-ui/core';
type Props = {
    mnsj: string;
    codNegocio: number;
}
const MensajeToken: React.FC<Props> = ({ mnsj, codNegocio }) => {
    const history = useHistory();
    const location = useLocation();

    return (
        <>
            <div id="myModal" className="modal">
                <div className="modal-content">
                    <h2>{mnsj}</h2>
                    {/* <p>{mnsj}</p> */}
                    <button id="btn-submit"
                        className="btn btn-primary site-main__btn g-recaptcha"
                        onClick={() => {
                            /* console.log(codNegocio)
                            if (codNegocio == 1) { */
                            history.push({
                                pathname: "/Inicio"
                            })
                            /*  } else {
                                 window.close()
                             } */
                        }}
                    >
                        Aceptar
                    </button>
                </div>
            </div >
        </>
    )
}

export default MensajeToken;